let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("go5We")), load("3P38h")]).then(() => parcelRequire('hCcnT'));